import { isArray, isEmpty, isEqual, map, groupBy } from 'lodash';
import React, { useEffect, useMemo, useState } from 'react';
import usePersonEntityTypeGroupSelector from '../../../data/hooks/usePersonEntityTypeGroupSelector';
import SpinnerError from '../../utils/SpinnerError';
import useT from '../../utils/Translations/useT';
import MultiselectFilter from './MultiselectFilter';
import usePersonEntityTypes from '../../../data/hooks/usePersonEntityTypes';
const OrgGroupPersonEntityTypeSelector = ({ onChange, title = '', value = [], orgGroupSelectorName, filter = {}, ...props }) => {
    const t = useT();
    const { personEntityTypesById, loading: isPetsLoading, error: petsError, } = usePersonEntityTypes();
    const orgGroupIds = useMemo(() => {
        let orgGroupIds = orgGroupSelectorName && filter && filter[orgGroupSelectorName];
        if (!orgGroupIds && (props === null || props === void 0 ? void 0 : props.orgGroupIds)) {
            orgGroupIds = props === null || props === void 0 ? void 0 : props.orgGroupIds;
        }
        return isArray(orgGroupIds) ? orgGroupIds : [orgGroupIds];
    }, [props, filter, orgGroupSelectorName]);
    const { personEntityTypeGroupSelector: personEntityTypeGroupSelectorNT, error, loading, } = usePersonEntityTypeGroupSelector({
        orgGroupIds,
        skip: isEmpty(orgGroupIds) || !orgGroupIds[0],
    });
    const personEntityTypeGroupSelector = useMemo(() => personEntityTypeGroupSelectorNT.map(pet => ({
        ...pet,
        name: t(pet.name),
    })), [personEntityTypeGroupSelectorNT, t]);
    const [_orgGroupIds, _setOrgGroupIds] = useState(orgGroupIds);
    useEffect(() => {
        if (!isEmpty(_orgGroupIds) &&
            !isEqual(_orgGroupIds, orgGroupIds) &&
            !loading) {
            _setOrgGroupIds(orgGroupIds);
            if (_orgGroupIds[0] &&
                !isEmpty(personEntityTypeGroupSelector) &&
                onChange) {
                onChange(map(personEntityTypeGroupSelector, 'id'));
            }
        }
    }, [
        loading,
        personEntityTypeGroupSelector,
        _orgGroupIds,
        onChange,
        orgGroupIds,
    ]);
    const isDisabled = useMemo(() => !personEntityTypeGroupSelector || !personEntityTypeGroupSelector.length, [personEntityTypeGroupSelector]);
    const options = useMemo(() => {
        if (isEmpty(personEntityTypeGroupSelector) ||
            isEmpty(personEntityTypesById)) {
            return [];
        }
        const { false: nonCore, true: core } = groupBy(personEntityTypeGroupSelector, item => { var _a; return (_a = personEntityTypesById[item.personEntityTypeId]) === null || _a === void 0 ? void 0 : _a.isCore; });
        const result = [];
        if (core) {
            result.push(core);
        }
        if (nonCore) {
            result.push(nonCore);
        }
        return result;
    }, [personEntityTypeGroupSelector, personEntityTypesById]);
    return (<SpinnerError error={error || petsError} inline={false} loading={loading || isPetsLoading}>
      <MultiselectFilter disabled={isDisabled} itemId={onItemId} options={options} title={title ? title : t('Person Entity')} value={value} onChange={onChange} {...props}/>
    </SpinnerError>);
};
export default OrgGroupPersonEntityTypeSelector;
const onItemId = item => item.id;
